export default "__VITE_ASSET__D2F93kR$__"